import { useCallback, useState } from 'react';

import { kebabCase } from 'lodash';
import { Copy } from 'lucide-react';
import { DefaultTooltip, Label, Input, FormGroup, Row, Col } from 'twyne-new.ui';

import { ControlledConfirmationPopover } from '@/components/ConfirmationPopover';
import { useAppAlert } from '@Components/AppAlert';
import { getInfo } from '@Components/Grid/components/Table/formatters';
import { useGrid } from '@Components/Grid/context';

export default function DuplicateEntity({ info, asLabel }) {
  const { row } = getInfo(info)
  const { definitions: { entityName }, events: { handleDuplicateEntry } } = useGrid()
  const { handleSuccess } = useAppAlert()

  const [title, setTitle] = useState('')
  const [slug, setSlug] = useState('')
  const [slugChanged, setSlugChanged] = useState(false)

  const handleSubmit = useCallback(async () => {
    await handleDuplicateEntry({ id: row.id, title, slug })
    handleSuccess(`${entityName} duplicated!`)
  }, [row, title, slug, handleDuplicateEntry, handleSuccess, entityName])

  const handleChangeSlug = useCallback(event => {
    const { value } = event.currentTarget;
    if (value && value.length) {
      setSlug(value)
      setSlugChanged(true)
    } else {
      setSlugChanged(false)
    }
  }, [])

  const handleChangeTitle = useCallback(event => {
    const { value } = event.currentTarget;
    setTitle(value)
    if (!slugChanged) {
      setSlug(kebabCase(value))
    }
  }, [slugChanged])

  const target = asLabel ? <span>Duplicate</span> : <DefaultTooltip content='Duplicate'><Copy size={16} /></DefaultTooltip>

  return <>
    <ControlledConfirmationPopover
      target={target}
      title={<span>Duplicate {entityName.toLowerCase()} <i>{`[#${row.id}] ${row.name || row.title}`}</i></span>}
      onSubmit={handleSubmit}
    >
      <Row>
        <Col>
          <FormGroup>
            <Label>New {entityName.toLowerCase()} title</Label>
            <Input name="title" value={title || ''} onChange={handleChangeTitle} required />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label>Slug</Label>
            <Input name="slug" value={slug || ''} onChange={handleChangeSlug} required />
          </FormGroup>
        </Col>
        <Col className='font-bold'>
          Are you sure you want duplicate this entry?
        </Col>
      </Row>
    </ControlledConfirmationPopover>
  </>
}
